import api from './api';

export interface Direccion {
  id: number;
  apodo: string;
  calle: string;
  numero: string;
  comuna: string;
  ciudad: string;
  region: string;
  codigo_postal?: string;
  referencia?: string;
  telefono: string;
  nombre_contacto: string;
  es_principal: boolean;
  fecha_creacion: string;
  fecha_actualizacion: string;
}

export interface DireccionFormData {
  apodo: string;
  calle: string;
  numero: string;
  comuna: string;
  ciudad: string;
  region: string;
  codigo_postal?: string;
  referencia?: string;
  telefono: string;
  nombre_contacto: string;
  es_principal?: boolean;
}

// Obtener todas las direcciones del usuario
export const getDirecciones = async (): Promise<Direccion[]> => {
  const response = await api.get('/auth/direcciones/');
  // La API puede devolver { results: [...] } o directamente [...]
  const data = response.data;
  return Array.isArray(data) ? data : (data.results || []);
};

// Crear una nueva dirección
export const createDireccion = async (data: DireccionFormData): Promise<Direccion> => {
  const response = await api.post<Direccion>('/auth/direcciones/', data);
  return response.data;
};

// Actualizar una dirección
export const updateDireccion = async (id: number, data: Partial<DireccionFormData>): Promise<Direccion> => {
  const response = await api.patch<Direccion>(`/auth/direcciones/${id}/`, data);
  return response.data;
};

// Eliminar una dirección
export const deleteDireccion = async (id: number): Promise<void> => {
  await api.delete(`/auth/direcciones/${id}/`);
};

// Marcar una dirección como principal
export const setDireccionPrincipal = async (id: number): Promise<Direccion> => {
  const response = await api.post<Direccion>(`/auth/direcciones/${id}/set_principal/`);
  return response.data;
};

// Validar dirección
export const validateDireccion = (data: DireccionFormData): { valid: boolean; errors: Record<string, string> } => {
  const errors: Record<string, string> = {};

  if (!data.calle || data.calle.trim().length === 0) {
    errors.calle = 'La calle es obligatoria';
  }

  if (!data.numero || data.numero.trim().length === 0) {
    errors.numero = 'El número es obligatorio';
  }

  if (!data.comuna || data.comuna.trim().length === 0) {
    errors.comuna = 'La comuna es obligatoria';
  }

  if (!data.ciudad || data.ciudad.trim().length === 0) {
    errors.ciudad = 'La ciudad es obligatoria';
  }

  if (!data.region || data.region.trim().length === 0) {
    errors.region = 'La región es obligatoria';
  }

  if (!data.telefono || data.telefono.trim().length === 0) {
    errors.telefono = 'El teléfono es obligatorio';
  }

  if (!data.nombre_contacto || data.nombre_contacto.trim().length === 0) {
    errors.nombre_contacto = 'El nombre de contacto es obligatorio';
  }

  return {
    valid: Object.keys(errors).length === 0,
    errors
  };
};
